import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  let breadcrumbPath = "";
  const { t } = useTranslation();

  return (
    <div
      style={{
        marginBottom: "20px",
        fontSize: "16px",
        textTransform: "capitalize",
      }}
    >
      <Link to="/Dashboard">{t("Dashboard")}</Link>
      {pathnames.map((name, index) => {
        breadcrumbPath += `/${name}`;
        const isLast = index === pathnames.length - 1;

        return (
          <span key={breadcrumbPath}>
            {" "}
            /{" "}
            {isLast ? (
              <span
                style={{
                  color: "#999",
                }}
              >
                {t(name)} 
              </span>
            ) : (
              <Link to={name === 'ScoreDetails' || 'AssessmentDetails' ? '#' : breadcrumbPath}>{t(name)} </Link>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
